import { AuthProvider } from './../auth/auth';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LiveSignal } from '../../models/Signal';

/*
  Generated class for the BtBackendProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BtBackendProvider {
    //PROD
    // private baseURL: string = 'https://us-central1-blocktrade-32c5c.cloudfunctions.net';

    //DEV
    private baseURL: string = 'https://us-central1-blocktistis-dev.cloudfunctions.net';

    constructor(public http: HttpClient, private auth: AuthProvider) {
    }

    private getAuthHeaders(): Observable<HttpHeaders> {
        return this.auth.afAuth.idToken
            .map(token => {
                return new HttpHeaders({
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                });
            })
    }

    setReferralId(refId: string): Observable<any> {
        const url = `${this.baseURL}/setRefId`;
        return this.getAuthHeaders()
            .flatMap(headers => {
                const payload = { refId: refId };    // success 200 response
                return this.http.post(url, payload, { headers: headers });
            })
    }

    adminSetReferralId(uid: string, refId: string): Observable<any> {
        const url = `${this.baseURL}/adminSetRefId`;
        return this.getAuthHeaders()
            .flatMap(headers => {
                const payload = { uid: uid, refId: refId };    // success 200 response
                return this.http.post(url, payload, { headers: headers });
            })
    }

    createSubscription(token: string, planId: string): Observable<any> {
        const url = `${this.baseURL}/createSubscription`;

        return this.getAuthHeaders()
            .flatMap(headers => {
                const payload = {
                    token: token,
                    planId: planId
                };    // success 200 response
                return this.http.post(url, payload, { headers: headers });
            })
    }

    endSubscription(): Observable<any> {
        const url = `${this.baseURL}/endSubscription`;
        return this.getAuthHeaders()
            .flatMap(headers => {
                return this.http.post(url, {}, { headers: headers });
            })
    }

    createPromoter(): Observable<any> {
        const url = `${this.baseURL}/setNewPromoter`;
        return this.getAuthHeaders()
            .flatMap(headers => {
                return this.http.post(url, {}, { headers: headers });
            })
    }

    getCoinbaseCharge(plan: string): Observable<any> {
        const url = `${this.baseURL}/getCoinbaseCharge`;
        return this.getAuthHeaders()
            .flatMap(headers => {
                const payload = {
                    plan: plan
                };
                return this.http.post(url, payload, { headers: headers });
            })
    }

    getAuthToken(): Observable<any> {
        const url = `${this.baseURL}/getAuthToken`;
        return this.getAuthHeaders()
            .flatMap(headers => {
                return this.http.get(url, { headers: headers });
            })
    }

    setStripeCreditCard(token: string, plan: string): Observable<any> {
        const url = `${this.baseURL}/createStripeSubscription`;
        if (plan) {
            return this.getAuthHeaders()
                .flatMap(headers => {
                    const payload = {
                        token: token,
                        plan: plan
                    };    // success 200 response
                    return this.http.post(url, payload, { headers: headers });
                })
        } else {
            return Observable.of(null);
        }
    }

    async getClosedSignals(): Promise<LiveSignal[]>{
        let response = await this.http.get(`${this.baseURL}/getClosedSignals`).toPromise();
        let signals: LiveSignal[] = [];
        for(let key in response){
            const signal = response[key];
            const liveSignal: LiveSignal = new LiveSignal(signal);
            liveSignal.key = key;
            signals.push(liveSignal);
        }
        signals.sort((a, b) => parseInt(a.data.timestamp) - parseInt(b.data.timestamp));
        return signals;
    }
}



// WEBPACK FOOTER //
// ./src/providers/bt-backend/bt-backend.ts